import { render, staticRenderFns } from "./ProgramComponent.vue?vue&type=template&id=41131a67"
import script from "./ProgramComponent.vue?vue&type=script&lang=js"
export * from "./ProgramComponent.vue?vue&type=script&lang=js"
import style0 from "./ProgramComponent.vue?vue&type=style&index=0&id=41131a67&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports